import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppLayoutContextConsumer } from '@occc-app/design-system';
import { getCreatePageLinks } from '@occc-app/routes/ProgramManagement/utils';
import { Offer_Engagement_Type } from '@occc/graphql';
import { OfferType } from '@occc-app/offerValidationService/types';

import { OfferCreateConfigurePage } from '@occc-app/routes/Offer/OfferCreatePage/OfferCreateConfigurePage';
import { Flow_Types } from '@occc-app/offerHelpers/types';
import { useMakeOffersFilter } from '@occc-app/offerHelpers/hooks/use-make-offers-filter.hook';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';
import { LoyaltyEventConfigureFormInitialValues, LoyaltyEventConfigureFormValues } from '../types';
import { messages } from '../messages';
import { transformOfferToInitialValues } from '../components/LoyaltyEventConfigureForm/utils/configureFormInitialValues';
import { getConfigureFormOperations } from '../components/LoyaltyEventConfigureForm/utils/configureFormOperations';
import { LoyaltyEventConfigureForm } from '../components/LoyaltyEventConfigureForm/LoyaltyEventConfigureForm';
import { routeCreator } from '../utils';

export const LoyaltyEventCreatePageContainer = () => {
  const navigate = useNavigate();

  const links = useMemo(
    () => getCreatePageLinks('New Loyalty Event Offer', OfferType.LoyaltyEvent),
    [],
  );
  useAppLayoutContextConsumer(links);

  const makeOffersFilter = useMakeOffersFilter();

  return (
    <OfferCreateConfigurePage<
      LoyaltyEventConfigureFormValues,
      LoyaltyEventConfigureFormInitialValues
    >
      pageTitle='Program Management > Create'
      subtitle={messages.subtitle}
      offerType={OfferType.LoyaltyEvent}
      engagementType={Offer_Engagement_Type.Behavioral}
      getConfigureOperations={getConfigureFormOperations}
      getInitialValues={transformOfferToInitialValues}
      onOfferCreated={(offerId) =>
        navigate(routeCreator.configureWithTab(offerId, CampaignComponentTabs.Target))
      }
      renderConfigureForm={({ onSubmit, initialValues, loading }) => (
        <LoyaltyEventConfigureForm
          onSubmit={onSubmit}
          initialValues={initialValues}
          loading={loading}
          onCancelClick={() => navigate(routeCreator.base())}
          makeOffersFilter={makeOffersFilter}
          currentFlowType={Flow_Types.Configure}
          isFormEditable
        />
      )}
    />
  );
};
